import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { QuoteJourney } from '../components/QuoteJourney';

export const quoteRoutes: RouteObject[] = [
    {
        element: <PermissionRoute requiredPermissions={[{ resource: 'quote', action: 'browse' }]} />,
        children: [
            { path: '/service-plans/new', element: <QuoteJourney /> },
            { path: '/service-plans/new/:quoteId', element: <QuoteJourney /> },
        ],
    },
];
